import React from 'react';
import Header1 from '../components/Header1';
import Footer from '../components/Footer';
import './Platform.css';

const Platform = () => {
    return (
        <>
            <Header1 />
            <div className="platform-page">
                <section className="platform-hero">
                    <h1>Our Platform</h1>
                    <p>Discover the powerful features that make Digicard the ultimate tool for modern networking.</p>
                </section>

                <div className="platform-main">
                    <section className="platform-feature">
                        <h2>Digital Business Cards</h2>
                        <p>Our Digital Business Cards allow you to create, share, and manage your professional identity with ease. Customize your card to include all your essential information, and share it instantly with anyone, anywhere. No need for physical cards—everything is digital and always accessible.</p>
                        <img src="/businesscards.png" alt="Digital Business Cards" />
                    </section>

                    <section className="platform-feature">
                        <h2>Contacts</h2>
                        <p>Manage and organize your professional connections with our Contacts feature. Easily import, categorize, and search your contacts, ensuring that your network is always within reach. Whether you're following up after a meeting or planning an outreach, our tool keeps you connected.</p>
                        <img src="/contacts.png" alt="Contacts" />
                    </section>

                    <section className="platform-feature">
                        <h2>Email Signatures</h2>
                        <p>Design custom email signatures that represent your brand. Our intuitive tools let you create professional, on-brand signatures that make every email you send more impactful. Stay consistent and make a lasting impression with every message.</p>
                        <img src="/emailsignatures.png" alt="Email Signatures" />
                    </section>

                    <section className="platform-feature">
                        <h2>Virtual Backgrounds</h2>
                        <p>Enhance your online meetings with personalized Virtual Backgrounds. Whether you're working remotely or attending virtual conferences, our backgrounds help you maintain a professional appearance, wherever you are.</p>
                        <img src="/backgrounds.png" alt="Virtual Backgrounds" />
                    </section>

                    <section className="platform-feature">
                        <h2>Analytics</h2>
                        <p>Track and analyze the performance of your networking efforts with our Analytics feature. Gain insights into how your digital cards are being used, understand your audience, and make data-driven decisions to enhance your professional presence.</p>
                        <img src="/analytics.png" alt="Analytics" />
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Platform;
